import { Help as HelpIcon } from '@tunasong/icons'
import {Dialog, ShortcutBox, Typography, shortcuts, MenuItem, ListItemIcon, type MenuItemProps} from '@tunasong/ui-lib'
import type { FC, MouseEvent } from 'react'
import { useState } from 'react'

export interface HelpMenuItemProps extends Omit<MenuItemProps, 'button'> {
  className?: string
  onClose?: () => void
}

export const HelpMenuItem: FC<HelpMenuItemProps> = props => {
  const { className, onClose, onClick, ...restProps } = props
  const [showHelp, setShowHelp] = useState(false)

  const handleShowHelp = (ev: MouseEvent<HTMLDivElement>) => {
    ev.preventDefault()
    ev.stopPropagation()
    if (onClick) {
      onClick(ev)
    }
    setShowHelp(true)
  }
  const handleHideHelp = () => {
    setShowHelp(false)
    if (onClose) {
      onClose()
    }
  }

  return (
    <>
      <MenuItem className={className} title="Show help" color="inherit" onClick={handleShowHelp} {...restProps}>
        <ListItemIcon>
          <HelpIcon />
        </ListItemIcon>
        <Typography variant="inherit">Help</Typography>
      </MenuItem>
      <Dialog open={showHelp} onClose={handleHideHelp} title="Keyboard Shortcuts">
        {Object.values(shortcuts).map((s, idx) => (
          <ShortcutBox key={idx} shortcut={s} />
        ))}
      </Dialog>
    </>
  )
}

export default HelpMenuItem
